import React, {useCallback, useContext, useEffect, useState} from 'react';
import {
	AccordionActions,
	AccordionDetails, Button,
	Card,
	CardActionArea,
	CardContent,
	CardHeader,
	Chip, MenuItem, Tooltip,
	Typography
} from "@mui/material";
import Grid from "@mui/material/Grid";
import clsx from "clsx";
import { Alert, AlertTitle, Rating, Skeleton } from '@mui/material';
import {amber, indigo} from "@mui/material/colors";
import moment from "moment";
import PersonOutlineTwoToneIcon from "@mui/icons-material/PersonOutlineTwoTone";
import withStyles from '@mui/styles/withStyles';
import {useTheme} from "@mui/styles";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {TamponiContext} from "../IntervistaOld";
import {getAllAgende, prenotaTampone, updatePrenotazione} from "../../../../../services/TamponiServices";
import {useForm} from "react-hook-form";
import CustomDateInput from "../../../../widgets/inputs/CustomDateInput";
import CustomSelect from "../../../../widgets/inputs/CustomSelect";
import {valueRegister, valueRegisterNone} from "../../../../../utils/RegisterUtils";
import CustomMultiText from "../../../../widgets/inputs/CustomMultiText";
import {criteri, motivazioni} from "../../../../../utils/arrays/prenotazioni";
import CustomText from "../../../../widgets/inputs/CustomText";
import {setOpenSnackbar} from "../../../../../services/AppServices";
import {AnagraficaContext, AppContext} from "../../../../../App";

const PrenotaTamponeStep = ({idSoggetto, setStep}) => {
	const classes = BaseStyle();
	let theme = useTheme();
	const tamponiContext = useContext(TamponiContext);
	const [selected, setSelected] = useState("");
	const [fasciaSelected, setFasciaSelected] = useState("");
	let fasce = new Array(12).fill(":00");
	const [submit, setSubmit] = useState(false);
	const [submitUpdate, setSubmitUpdate] = useState(false);
	const {reset, handleSubmit, control, errors, register} = useForm({mode: "onChange"});
	const appContext = useContext(AppContext);
	const anagraficaContext = useContext(AnagraficaContext);
	
	const onSubmit = useCallback((data, type) => {
		switch (type) {
			default:
				setSubmit(true);
				prenotaTampone({
					...data,
					soggetto: {idSoggetto:idSoggetto}
				}, tamponiContext.dispatch)
				break;
			case "prenota":
				setSubmitUpdate(true);
				updatePrenotazione({
					...data,
					...tamponiContext.state.prenotazioneEffettuata,
					agendaId: selected?.id,
					nfascia: fasciaSelected,
					stato: "Prenotazione conclusa",
					active: false,
				}, tamponiContext.dispatch)
				break;
		}
	}, [idSoggetto, tamponiContext.dispatch, fasciaSelected, selected, tamponiContext.state.prenotazioneEffettuata]);
	
	useEffect(() => {
		if (submit && !tamponiContext.state.loadingPrenotaTampone && tamponiContext.state.errorPrenotaTampone === "") {
			setSubmit(false);
			setOpenSnackbar("success", "La prenotazione è stata creata, ora puoi indicare anche la data e l'ora se necessario.", appContext.dispatch);
		} else if (submit && !tamponiContext.state.loadingPrenotaTampone && tamponiContext.state.errorPrenotaTampone !== "") {
			setSubmit(false)
			setOpenSnackbar("error", tamponiContext.state.errorPrenotaTampone, appContext.dispatch);
		}
	}, [submit, tamponiContext.state.loadingPrenotaTampone, tamponiContext.state.errorPrenotaTampone, appContext.dispatch, anagraficaContext.dispatch, reset])
	
	useEffect(() => {
		if (submitUpdate && !tamponiContext.state.loadingUpdatePrenotazione && tamponiContext.state.errorUpdatePrenotazione === "") {
			setSubmitUpdate(false);
			setOpenSnackbar("success", "Prenotazione avvenuta con successo", appContext.dispatch);
		} else if (submitUpdate && !tamponiContext.state.loadingUpdatePrenotazione && tamponiContext.state.errorUpdatePrenotazione !== "") {
			setSubmitUpdate(false);
			setOpenSnackbar("error", tamponiContext.state.errorUpdatePrenotazione, appContext.dispatch);
		}
	}, [submitUpdate, tamponiContext.state.loadingUpdatePrenotazione, tamponiContext.state.errorUpdatePrenotazione, appContext.dispatch])
	
	useEffect(() => {
		getAllAgende({enable: true}, tamponiContext.dispatch);
	}, [tamponiContext.dispatch])
	
	return (
        <React.Fragment>
            <AccordionDetails>
				<Grid container spacing={3}>
					
					<Grid item xs={12} sm={4}>
						<CustomDateInput
							name={"dataRichiesta"}
							label={"Data richiesta"}
							control={control}
							defaultValue={null}
							minDate={new Date()}
							rules={{required: true}}
							error={errors["dataRichiesta"]}
						/>
					</Grid>
					<Grid item xs={12} sm={8}>
						<CustomSelect
							control={control}
							rules={valueRegister}
							name={"luogo"}
							label={"Luogo prenotazione"}
							autoFocus={false}
							none={true}
							defaultValue={""}
							noneValue={""}
							error={errors["luogo"]}
						>
							<MenuItem value={"Hotspot"}>
								Hotspot
							</MenuItem>
							<MenuItem value={"Domicilio"}>
								Domicilio
							</MenuItem>
						</CustomSelect>
					</Grid>
					<Grid item xs={12}>
						<CustomMultiText
							inputRef={register({required: true})}
							name={"note"}
							label={"Note"}
							autoFocus={false}
							error={errors["note"]}
							rows={5}
						/>
					</Grid>
					
					<Grid item xs={12}>
						<CustomSelect
							control={control}
							rules={valueRegisterNone}
							name={"criterioEpidemiologico"}
							label={"Criterio epidemiologico"}
							autoFocus={false}
							defaultValue={""}
							none={true}
							noneValue={""}
							error={errors["criterioEpidemiologico"]}
						>
							{criteri.map((val, key) => {
								return (
									<MenuItem value={val} key={key}>
										{val}
									</MenuItem>
								);
							})}
						</CustomSelect>
					</Grid>
					<Grid item xs={12}>
						<CustomSelect
							control={control}
							rules={valueRegisterNone}
							name={"motivazione"}
							label={"Motivazione"}
							autoFocus={false}
							none={true}
							defaultValue={""}
							noneValue={""}
							error={errors["motivazione"]}
						>
							{motivazioni.map((val, key) => {
								return (
									<MenuItem value={val} key={key}>
										{val}
									</MenuItem>
								);
							})}
						</CustomSelect>
					</Grid>
					<Grid item xs={12} sm={6}>
						<CustomText
							control={control}
							rules={{required: false}}
							name={"medicoRichiedente"}
							label={"Medico richiedente"}
							autoFocus={false}
							type={"text"}
							error={errors["medicoRichiedente"]}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<CustomText
							control={control}
							rules={{required: false}}
							name={"contattoRichiedente"}
							label={"Contatto richiedente"}
							autoFocus={false}
							type={"text"}
							error={errors["contattoRichiedente"]}
						/>
					</Grid>
					
					{
						!tamponiContext.state.loadingPrenotaTampone && tamponiContext.state.errorPrenotaTampone === "" &&
						<React.Fragment>
							<Grid item xs={12}>
								<Typography className={classes.heading}><b><span
									style={{fontSize: 26, color: theme.palette.primary.main}}>1. </span> Scegli la data
								</b><br/>
									<span style={{color: theme.palette.text.secondary}}>Scegli tra le alternative la data per cui vuoi prenotare
								un tampone. In caso non siano presenti posti puoi aggiungerli dalla sezione precedente</span>
								</Typography>
							</Grid>
							<Grid item xs={12} className={classes.flexStart}>
								{
									tamponiContext.state.loadingGetAllAgende ?
										<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
											<CardHeader
												avatar={<Skeleton variant="circular" height={40} width={40}/>}
												title={<Skeleton width={180}/>}
												subheader={<Skeleton width={260}/>}
												action={<Skeleton variant="circular" height={20} width={20}/>}
												style={{paddingBottom: 2}}
											/>
											<CardContent style={{paddingTop: 0, marginTop: -35}}>
												<Skeleton height={200}/>
											</CardContent>
										</Card> : tamponiContext.state.errorGetAllAgende !== "" ?
											<Alert severity="error" style={{borderRadius: 24}}>
												<AlertTitle>Errore</AlertTitle>
												Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta gli
												sviluppatori.
											</Alert> :
											tamponiContext.state.agende.length === 0 ? "Non ci sono agende..." :
												tamponiContext.state.agende.map((agenda, index) => {
													return (
														<Card key={index} className={clsx(classes.roundBorder, classes.margin1)}
														      style={{
															      width: 200,
															      backgroundColor: selected.id === agenda.id ? indigo["A700"] : "",
															      color: selected.id === agenda.id ? "#FFF" : ""
														      }}>
															<CardActionArea onClick={() => setSelected(agenda)}>
																<CardHeader
																	title={<Typography><b>{moment(agenda.data).format("DD/MM/YYYY")}</b></Typography>}
																	subheader={<Typography>{agenda.luogo}</Typography>}
																/>
																<CardContent>
																	<Chip style={{fontSize: 20, backgroundColor: amber[500], width: 160}}
																	      label={
																		      <React.Fragment>
																			      <b>{agenda["postiR"]}</b> / {agenda["postiI"]}
																		      </React.Fragment>
																	      }/>
																</CardContent>
															</CardActionArea>
														</Card>
													)
												})
								}
							</Grid>
							{selected !== "" && <Grid item xs={12}>
								<Typography className={classes.heading}><b><span
									style={{fontSize: 26, color: theme.palette.primary.main}}>2. </span> Ottimo!, ora passiamo alla
									scelta della fascia oraria
								</b><br/>
									<span style={{color: theme.palette.text.secondary}}>Scegli tra le alternative la fascia oraria per cui vuoi
								prenotare un tampone. In caso non siano presenti posti puoi aggiungerli dalla sezione precedente</span>
								</Typography>
							</Grid>}
							{
								selected !== "" &&
								<Grid item xs={12} className={classes.flexStart}>
									{
										fasce.map((fascia, index) => {
											return (
												<Card key={index} className={clsx(classes.roundBorder, classes.margin1)} style={{
													width: 220, backgroundColor: fasciaSelected === (index + 1) ? indigo["A700"] : "",
													color: fasciaSelected === (index + 1) ? "#FFF" : ""
												}}>
													<CardActionArea disabled={selected["fascia" + (index + 1) + "R"] <= 0}
													                onClick={() => setFasciaSelected((index + 1))}>
														<CardContent style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
															<Typography align={"center"}>
																<b>{" " + (index + 8) + fascia + " - " + (index + 9) + fascia}</b>
															</Typography>
															<Typography align={"center"} style={{
																paddingTop: 10,
																paddingBottom: 4
															}}>Disponibili: <b>{selected["fascia" + (index + 1) + "R"]}</b> posti</Typography>
															<StyledRating
																readOnly
																defaultValue={
																	5 - (5 * (selected["fascia" + (index + 1) + "R"]) / (selected["fascia" + (index + 1) + "I"]))
																}
																precision={0.5}
																icon={<PersonOutlineTwoToneIcon fontSize="inherit"/>}
															/>
															{
																selected["fascia" + (index + 1) + "Tag"] &&
																<Chip label={selected["fascia" + (index + 1) + "Tag"]}/>
															}
														</CardContent>
													</CardActionArea>
												</Card>
											)
										})
									}
								</Grid>
							}
						</React.Fragment>
					}
				</Grid>
			</AccordionDetails>
            <AccordionActions>
				{selected === "" && <Tooltip title={"Crea una prenotazione"}>
					<Button size={"small"} color={"secondary"} variant={"contained"}
					        disableElevation disabled={submit}
					        className={classes.roundButton}
					        style={{borderRadius: 24}}
					        onClick={handleSubmit(data => onSubmit(data, "crea"))}
					>
						<b>Crea prenotazione</b>
					</Button>
				</Tooltip>}
				{fasciaSelected !== "" && <Tooltip title={"Prenota un tampone"}>
					<Button size={"small"} color={"secondary"} variant={"contained"}
					        disableElevation disabled={submit}
					        className={classes.roundButton}
					        style={{borderRadius: 24}}
					        onClick={handleSubmit(data => onSubmit(data, "prenota"))}
					>
						<b>Prenota tampone</b>
					</Button>
				</Tooltip>}
				<Tooltip title={"Prosegui con il passo successivo"}>
					<Button size={"small"} color={"primary"} variant={"contained"}
					        disableElevation disabled={submit}
					        className={classes.roundButton}
					        style={{borderRadius: 24}}
					        onClick={() => {
						        setSelected("");
						        setFasciaSelected("");
						        setStep(7);
					        }}
					>
						<b>Prosegui</b>
					</Button>
				</Tooltip>
			</AccordionActions>
        </React.Fragment>
    );
};

const StyledRating = withStyles({
	iconFilled: {
		color: '#ff6d75',
	},
	iconHover: {
		color: '#ff3d47',
	},
})(Rating);

export default React.memo(PrenotaTamponeStep)
